import axios from './axios';

export const registerStaff = (staffInfo) => axios.post('/api/Users/Register', staffInfo);

export const verifyOtp = (otpInfo) => axios.post('/api/Users/VerifyOtp', otpInfo);

export const resendOtp = (email) => axios.post('/api/Users/ResendOtp?email=' + encodeURIComponent(email));

export const loginStaff = (staffInfo) => axios.post('/api/Users/Login', staffInfo); 

export const forgotPassword = (staffInfo) => axios.post('/api/Users/ForgotPassword', staffInfo); 

export const resetPassword = (staffInfo) => axios.post('/api/Users/ResetPassword', staffInfo); 